webpackJsonp([231457999656378],{

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavLink = __webpack_require__(12);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavLinkPlaceholder = __webpack_require__(13);
	
	var _NavLinkPlaceholder2 = _interopRequireDefault(_NavLinkPlaceholder);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'docs-header', id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'CLI'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Documentation for the Command Line Interface'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'docs-content' },
	        _react2.default.createElement(
	          'ul',
	          { id: 'markdown-toc' },
	          _react2.default.createElement(_NavLink2.default, { title: 'Introduction', url: '/cli/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Top Level'
	          ),
	          _react2.default.createElement(_NavLink2.default, { title: 'new', url: '/cli/lore-generate-new/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Extractors'
	          ),
	          _react2.default.createElement(_NavLink2.default, { title: 'extract action', url: '/cli/lore-extract-action/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'extract reducer', url: '/cli/lore-extract-reducer/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Generators'
	          ),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate action', url: '/cli/lore-generate-action/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate collection', url: '/cli/lore-generate-collection/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate component', url: '/cli/lore-generate-component/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate generator', url: '/cli/lore-generate-generator/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate hook', url: '/cli/lore-generate-hook/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate model', url: '/cli/lore-generate-model/' }),
	          _react2.default.createElement(_NavLink2.default, { title: 'generate reducer', url: '/cli/lore-generate-reducer/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Misc'
	          ),
	          _react2.default.createElement(_NavLink2.default, { title: 'Extending the CLI', url: '/cli/misc/extending-the-cli/' })
	        ),
	        children
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CLI = __webpack_require__(136);
	
	var _CLI2 = _interopRequireDefault(_CLI);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _CLI2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'CLI'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The CLI for Lore is intended to be a complimentary tool for the application, and is designed in a way that allows it be extended from ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'within a project'
	      ),
	      '. This means that you can add new commands to the CLI as well as overwrite existing commands, and all without leaving your project, or without needing to submit a PR to modify the CLI itself.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While the CLI originally started off as a simple convenience for generating basic project files, and was not expected to be useful much beyond the Quickstart, the inclusion of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'extract'
	      ),
	      ' commands have dramatically changed that relationship and have made the CLI useful as a permanent tool.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Types of Commands'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Beyond the ability to generate a new project, there are two types of commands in the CLI.'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Generators'
	          ),
	          ' are used to add common files (like components, actions, reducers) to your project, and include flags for generating those files in ES5, ES6 or ESNext style syntax.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Generators can be especially useful when you need to override a default action or reducer.'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Extractors'
	          ),
	          ' are used to extract files that mirror functionality that the framework is providing through conventions. These are different from generators in the sense that aren\'t intended to be a blank starting point; they\'re intended to say "show me what the framework is doing".'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Extractors can be especially useful when you need to override a default action or reducer, but don\'t need to create something super custom. This allows you to start from what the framework is already doing and simplify modify it.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'How is the CLI Configured?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The CLI is controlled through the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '.lorerc'
	      ),
	      ' file at the root of your project, which looks like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        {\n          "generators": {\n            "language": "es5"\n          },\n          "commands": {}\n        }\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        {\n          "generators": {\n            "language": "es6"\n          },\n          "commands": {}\n        }\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        {\n          "generators": {\n            "language": "esnext"\n          },\n          "commands": {}\n        }\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'By default, this file is the same for all projects, except for the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'language'
	      ),
	      ' specified for the project (which controls what generated files will look like).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The file contains two keys; ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'generators'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'commands'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'The settings for ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'generators'
	          ),
	          ' control what generated files will look like, such as when using the command ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'lore generate component Header'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'The settings for ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'commands'
	          ),
	          ' control what commands are available. This is your extension point for overriding the existing commands or extending the CLI with new commands.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A version of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '.lorerc'
	      ),
	      ' file that completely replaces the default set of CLI commands looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        "generators": {\n          "language": "es5"\n        },\n        "commands": {\n          "new": "lore-generate-new",\n          "extract": {\n            "description": "Create files that mirror the blueprint behavior",\n            "commands": {\n              "action": "lore-extract-action",\n              "reducer": "lore-extract-reducer"\n            }\n          },\n          "generate": {\n            "description": "Generate common project files",\n            "commands": {\n              "action": "lore-generate-action",\n              "collection": "lore-generate-collection",\n              "component": "lore-generate-component",\n              "generator": "lore-generate-generator",\n              "hook": "lore-generate-hook",\n              "model": "lore-generate-model",\n              "reducer": "lore-generate-reducer"\n            }\n          }\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'commands'
	      ),
	      ' key is how you signal to the CLI that you have something you need to add to it.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to add a command at the root, such as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore hello <arguments>'
	      ),
	      ', you would add it by specifying a key called "hello" with a value pointing to the module location:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        "generators": {\n          "language": "es5"\n        },\n        "commands": {\n          "hello": "./commands/folder-name"\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The value can be a relative path like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        './commands/folder-name'
	      ),
	      ', an absolute path like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/Users/jason/some-folder/command-folder'
	      ),
	      ', or a node_module like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'module-name'
	      ),
	      '. If you provide a node_module, the CLI will first look in the project\'s node_modules directory, and then look in the global node_modules directory before throwing an error if it can\'t find it in either location.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to create a nested command, like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore hello world <arguments>'
	      ),
	      ' then you need to nest your command inside a category, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        "generators": {\n          "language": "es5"\n        },\n        "commands": {\n           "description": "Describe what commands in this category are for",\n            "hello": {\n              "world": "./commands/folder-name"\n            }\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The category description is completely optional. It defaults to an empty string. If you specify a description for a category that exists by default, such as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'extract'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'generate'
	      ),
	      ' it will override the default description.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-index-js-b0ee488054e1058aa5db.js